var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "td",
    {
      class: {
        "positive-number":
          _vm.column.id === "added_amount" && _vm.item.added_amount.value,
        "negative-number":
          _vm.column.id === "withdraw_amount" && _vm.item.withdraw_amount.value,
      },
    },
    [
      _vm.column.id === "date_user"
        ? [_vm._v(" " + _vm._s(_vm.item.date_user.value) + " ")]
        : _vm._e(),
      _vm.column.id === "amount_before"
        ? [
            _c(
              "span",
              {
                staticStyle: {
                  display: "inline-block",
                  width: "100%",
                  "text-align": "right",
                },
              },
              [_vm._v(_vm._s(_vm.item.amount_before.value))]
            ),
          ]
        : _vm._e(),
      _vm.column.id === "added_amount" && _vm.item.added_amount.value
        ? [
            _c(
              "span",
              {
                staticStyle: {
                  display: "inline-block",
                  width: "100%",
                  "text-align": "right",
                },
              },
              [_vm._v(_vm._s(_vm.item.added_amount.value))]
            ),
          ]
        : _vm._e(),
      _vm.column.id === "withdraw_amount" && _vm.item.withdraw_amount.value
        ? [
            _c(
              "span",
              {
                staticStyle: {
                  display: "inline-block",
                  width: "100%",
                  "text-align": "right",
                },
              },
              [_vm._v(_vm._s(_vm.item.withdraw_amount.value))]
            ),
          ]
        : _vm._e(),
      _vm.column.id === "amount_after"
        ? [
            _c(
              "span",
              {
                staticStyle: {
                  display: "inline-block",
                  width: "100%",
                  "text-align": "right",
                },
              },
              [_vm._v(_vm._s(_vm.item.amount_after.value))]
            ),
          ]
        : _vm._e(),
      _vm.column.id === "transaction_type"
        ? [_vm._v(" " + _vm._s(_vm.item.transaction_type.value) + " ")]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }